/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import SmartTable from 'shared/ui/components/tables/SmartTable.vue';

// Mixins
import emailModalLauncher from 'shared/ui/mixins/modal-launchers/email';

// Constants
const MIN_SEARCH_LENGTH = 3;

const STATUSES_ICONS = {
    cancelled: 'ic-x-circle',
    scheduled: 'ic-time',
    sending: 'ic-navigation',
    sent: 'ic-check-circle',
    failed: 'icon-warning'
};

const __vue_script__ = {
    name: 'ScheduledEmails',

    components: { SmartTable },

    mixins: [emailModalLauncher],

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            canSendEmails: this.$services.user.hasPermission('event_actions.send_email', { event_id: this.params.event._id }),
            currentPage: 1,
            items: [],
            searchTerm: '',
            totalItems: 0,
            itemPerPage: this.$services.emails.EMAILS_PER_PAGE
        };
    },

    watch: {
        searchTerm(value) {
            if (value && value.length >= MIN_SEARCH_LENGTH || value.length === 0) {
                this.loadContents();
            }
        }
    },

    created() {
        this.loadContents();
    },

    methods: {
        async loadContents() {
            try {
                const eventId = this.params.event._id;

                const { total, items } = await this.$services.emails.getScheduledEmails(eventId, this.currentPage, this.searchTerm);
                this.totalItems = total;

                /** @type {ScheduledEmail[]} */
                this.items = items;

            } catch (error) {
                console.error('[ScheduledEmails] Could not load scheduled emails', error.message);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later').toString(),
                    type: 'error'
                });
            }
        },

        /**
         * Go to the selected page
         *
         * @param {Number} page the page to select
         */
        setCurrentPage(page) {
            this.currentPage = page;
            this.loadContents();
        },

        /**
         * Prompts the user for mailing deletion
         *
         * @param {ScheduledEmail} item the mailing to delete
         */
        promptDelete(item) {
            this.$modal.show('dialog', {
                text: this.$t('emailing.messages.prompt_delete'),
                buttons: [
                    {
                        title: this.$t('general.dismiss'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.confirm'),
                        handler: async () => {
                            this.deleteMailing(item);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * Deletes the requested mailing
         *
         * @param {ScheduledEmail} item the mailing to delete
         */
        async deleteMailing(item) {
            try {
                await this.$services.emails.deleteMailing(this.params.event._id, item._id);
                // Refresh content
                await this.loadContents();
                this.$refs['table'].unselectAll();
            } catch (error) {
                console.error('[ScheduledEmails] Could not delete mailing', error.message);

                this.$notify({
                    group: 'flashes',
                    title: this.$i18n.t('general.error_occurred').toString(),
                    text: this.$i18n.t('general.try_later').toString(),
                    type: 'error'
                });
            }
        },

        /**
         * Returns the right CSS class for the status icon
         *
         * @param {ScheduledEmail["status"]} status
         *
         * @returns {string} the icon corresponding to the current status
         */
        statusIconClass(status) {
            return STATUSES_ICONS[status];
        },

        /**
         * Gets the template link
         *
         * @param {ScheduledEmail} item the mailing to get the link for
         *
         * @returns {string} the template link
         */
        templateLink(item) {
            const route = get(this.$services.blueprint, 'blueprint.modules.emailing.controllers["mailing-doc"].route');
            return route
                .replace(':eventId', this.params.event._id)
                .replace(':modelId', item._id);
        },

        /**
         * Emailing modal success handler
         *
         * @param {object} data the send mail result
         */
        onSendEmailSuccess(data) {
            console.info('[ScheduledEmails] Send email success', data);
            this.loadContents();
        },

        /**
         * Checks if the delete button should be visible for the given item
         *
         * @param {ScheduledEmail} item
         *
         * @returns {boolean}
         */
        shouldShowDeleteButton(item) {
            return item.status !== 'sent' && item.status !== 'cancelled';
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scheduled-emails" },
    [
      _c("smart-table", {
        ref: "table",
        staticClass: "mailing",
        attrs: {
          items: _vm.items,
          event: _vm.params.event,
          "total-items": _vm.totalItems,
          "items-per-page": _vm.itemPerPage,
          "track-by": "id",
        },
        on: {
          next: _vm.setCurrentPage,
          previous: _vm.setCurrentPage,
          "select-page": _vm.setCurrentPage,
        },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function (ref) {
              return [
                _vm.canSendEmails
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function ($event) {
                            return _vm.openEmailModal(_vm.params.event)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("emailing.actions.send_email")))]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "headers",
            fn: function (ref) {
              return [
                _c("th", { staticClass: "template" }, [
                  _vm._v(_vm._s(_vm.$t("emailing.list.headers.template"))),
                ]),
                _c("th", { staticClass: "status" }, [
                  _vm._v(_vm._s(_vm.$t("emailing.list.headers.status"))),
                ]),
                _c("th", { staticClass: "to" }, [
                  _vm._v(_vm._s(_vm.$t("emailing.list.headers.to"))),
                ]),
                _c("th", { staticClass: "recipients" }, [
                  _vm._v(_vm._s(_vm.$t("emailing.list.headers.recipients"))),
                ]),
                _c("th", { staticClass: "open" }, [
                  _vm._v(_vm._s(_vm.$t("emailing.list.headers.open"))),
                ]),
                _c("th", { staticClass: "clicks" }, [
                  _vm._v(_vm._s(_vm.$t("emailing.list.headers.clicks"))),
                ]),
                _c("th", { staticClass: "sent" }, [
                  _vm._v(_vm._s(_vm.$t("emailing.list.headers.sent_at"))),
                ]),
                _c("th", { staticClass: "row-actions" }),
              ]
            },
          },
          {
            key: "row",
            fn: function (ref) {
              var item = ref.item
              return [
                _c("td", { staticClass: "template" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.templateLink(item),
                        title: item.template,
                      },
                    },
                    [_vm._v(_vm._s(item.template))]
                  ),
                ]),
                _c(
                  "td",
                  { staticClass: "status", class: item.status },
                  [
                    _c("i", { class: _vm.statusIconClass(item.status) }),
                    item.status === "scheduled"
                      ? [
                          item.scheduled_at
                            ? _c("templat", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("emailing.statuses." + item.status)
                                  )
                                ),
                                _c("span", { staticClass: "scheduled-at" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$utils.time.tsToFormat(
                                        item.scheduled_at,
                                        _vm.$const.DEFAULT_DATETIME_FORMAT,
                                        _vm.params.event.timezone
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            : [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("emailing.statuses.sending"))
                                  ),
                                ]),
                              ],
                        ]
                      : [
                          _vm._v(
                            _vm._s(_vm.$t("emailing.statuses." + item.status))
                          ),
                        ],
                  ],
                  2
                ),
                _c("td", { staticClass: "to" }, [
                  _vm._v(_vm._s(_vm.$t("emailing.targets." + item.to))),
                ]),
                _c("td", { staticClass: "recipients" }, [
                  _vm._v(_vm._s(item.recipients)),
                  item.status === "scheduled"
                    ? _c("i", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$t("emailing.messages.recipients_info"),
                            expression:
                              "$t('emailing.messages.recipients_info')",
                          },
                        ],
                        staticClass: "ic-info-fill",
                      })
                    : _vm._e(),
                ]),
                _c("td", { staticClass: "open" }, [
                  _vm._v(
                    _vm._s(
                      Number.isFinite(item.opens)
                        ? item.opens
                        : _vm.$t("general.not_available")
                    )
                  ),
                ]),
                _c("td", { staticClass: "clicks" }, [
                  _vm._v(
                    _vm._s(
                      Number.isFinite(item.clicks)
                        ? item.clicks
                        : _vm.$t("general.not_available")
                    )
                  ),
                ]),
                _c(
                  "td",
                  { staticClass: "sent" },
                  [
                    item.status !== "scheduled"
                      ? [
                          _vm._v(
                            _vm._s(
                              item.sent_at
                                ? _vm.$utils.time.tsToFormat(
                                    item.sent_at,
                                    _vm.$const.DEFAULT_DATETIME_FORMAT,
                                    _vm.params.event.timezone
                                  )
                                : _vm.$t("general.not_available")
                            )
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c("td", { staticClass: "row-actions" }, [
                  _c("div", { staticClass: "content-actions" }, [
                    _vm.shouldShowDeleteButton(item)
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-danger btn-icon single",
                            on: {
                              click: function ($event) {
                                return _vm.promptDelete(item)
                              },
                            },
                          },
                          [_c("i", { staticClass: "ic-trash-2" })]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/emailing/ScheduledEmails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__